module.exports = __webpack_public_path__ + "static/media/mu.74fd3c2b.png";